import { ParameterType, SortingType } from '@/study-search/enums';

import { IQuery, IUrlQueryConstructor } from '../../interfaces/url.interfaces';
import { Filter } from '../filter/Filter';
import AllowedFilterCombinationsPolicy from '../indexability/AllowedFilterCombinationsPolicy';

export class UrlQueryConstructor implements IUrlQueryConstructor {
	public getQuery(filters: Filter[], sorting: SortingType): IQuery {
		const nonIndexableFilters = filters.filter((_) => _.canNotBeIndexed());
		const indexableFilters = filters.filter((_) => _.canBeIndexed());

		if (AllowedFilterCombinationsPolicy.notSatisfiedBy(indexableFilters)) {
			indexableFilters.forEach((_) => nonIndexableFilters.push(_));
		}

		const countryFilter = filters.filter((_) => _.type === ParameterType.COUNTRY)[0];
		const areaFilter = filters.filter((_) => _.type === ParameterType.AREA)[0];
		if (
			countryFilter.canBeIndexed() &&
			areaFilter.canNotBeIndexed() &&
			areaFilter.values.length > 1 &&
			nonIndexableFilters.find((_) => _.type === ParameterType.COUNTRY) === undefined
		) {
			nonIndexableFilters.push(countryFilter);
		}

		const query: IQuery = {};
		nonIndexableFilters.forEach((_) => this.pushQueryPart(_, query));

		this.setSortingQueryPart(sorting, query);

		return query;
	}

	private pushQueryPart(filter: Filter, query: IQuery): void {
		if (filter.values.length > 0) {
			query[filter.type] = [...filter.values];
		}
	}

	private setSortingQueryPart(sorting: SortingType, query: IQuery): void {
		if (sorting !== SortingType.RELEVANCE) {
			query.sorting = sorting;
		}
	}
}
